import * as React from "react";
export const ContentPageInner = ({ children, }) => (React.createElement("div", { className: "flex flex-1 flex-col gap-4 justify-center items-center bg-gray-100 dark:bg-gray-900 p-4" }, children));
//# sourceMappingURL=ContentPageInner.js.map